export default __webpack_public_path__ + "static/media/empty-cart.459c22ce.gif";